import { render, staticRenderFns } from "./right-bottom-banner.vue?vue&type=template&id=590f1462&scoped=true&"
import script from "./right-bottom-banner.vue?vue&type=script&lang=ts&"
export * from "./right-bottom-banner.vue?vue&type=script&lang=ts&"
import style0 from "./right-bottom-banner.vue?vue&type=style&index=0&id=590f1462&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590f1462",
  null
  
)

export default component.exports